import { render } from "./forminvhero.vue?vue&type=template&id=39ca3ec9&scoped=true"
import script from "./forminvhero.vue?vue&type=script&lang=js"
export * from "./forminvhero.vue?vue&type=script&lang=js"

import "./forminvhero.vue?vue&type=style&index=0&id=39ca3ec9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-39ca3ec9"

export default script